<template>
    <div v-if="userData.about" class="profile-about-description" :class="descriptionOpen === true ? 'profile-about-description--open': '' ">
        <div class="profile-about-description__header">
            {{ (userData.user_type === 'USER_TYPE_ORGANIZATION') ? $store.getters.t('organizations_description_title') : $store.getters.t('user_description_title') }}
        </div>
        <div class="profile-about-description__body">
            <div class="profile-about-description__body-content" v-text="userData.about"></div>
            <a v-if="userData.about.length > 354" href="#" class="profile-about-description__body-more" @click.prevent="descriptionOpen = !descriptionOpen">{{$store.getters.t('organizations_description_toggle')}}</a>
        </div>
    </div>
</template>

<script>
export default {
    props:['userData'],
    name: "ProfileAboutDescription",
    data(){
        return{
            descriptionOpen: false,
        }
    },

    computed:{
        user(){
            return this.$store.getters.getUserData
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
